import type { ComponentProps } from "react"

export default function IndustryI(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M7.57143 6.28571C7.57143 5.57563 6.99579 5 6.28571 5C5.57563 5 5 5.57563 5 6.28571V10.5714C5 12.8107 6.4311 14.7156 8.42857 15.4216V25.5714C8.42857 26.5182 9.19609 27.2857 10.1429 27.2857C11.0896 27.2857 11.8571 26.5182 11.8571 25.5714V15.4216C13.8546 14.7156 15.2857 12.8107 15.2857 10.5714V6.28571C15.2857 5.57563 14.7101 5 14 5C13.2899 5 12.7143 5.57563 12.7143 6.28571V10.5714C12.7143 11.5232 12.1972 12.3542 11.4286 12.7989V6.28571C11.4286 5.57563 10.8529 5 10.1429 5C9.43278 5 8.85714 5.57563 8.85714 6.28571V12.7989C8.08854 12.3542 7.57143 11.5232 7.57143 10.5714V6.28571ZM16.1429 16.1429C16.1429 22.297 21.1317 27.2857 27.2857 27.2857V23.2143C23.3802 23.2143 20.2143 20.0483 20.2143 16.1429C20.2143 12.2374 23.3802 9.07143 27.2857 9.07143V5C21.1317 5 16.1429 9.98883 16.1429 16.1429ZM22.3571 16.1429C22.3571 13.4209 24.5638 11.2143 27.2857 11.2143V21.0714C24.5638 21.0714 22.3571 18.8648 22.3571 16.1429Z"
        fill={fill}
      />
    </svg>
  )
}
